export enum Fields {
  ROLE = 'role',
  TITLE = 'title',
  VALUE = 'value',
}
